import {
  INVALIDATE_CREANCES,
  INVALIDATE_VENTES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_PAIEMENT_CREANCES,
  INVALIDATE_CREANCES_CLIENT,
  INVALIDATE_ECRITURE,
} from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  UPDATE_CREANCE_API_ROUTE,
  PAIEMENT_CREANCE_API_ROUTE,
} from 'routes/api/endpoints';

const creanceApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    updateCreance: build.mutation({
      query: ({ id, ...updateData }) => ({
        url: `${UPDATE_CREANCE_API_ROUTE}${id}/`,
        method: 'PUT',
        body: updateData,
      }),
      invalidatesTags: [INVALIDATE_CREANCES],
    }),
    payCreance: build.mutation({
      query(body) {
        return {
          url: PAIEMENT_CREANCE_API_ROUTE,
          method: 'POST',
          body,
        };
      },
      // Un paiement modifie le statut dans les ventes, transactions,
      // historiques de paiement et les écritures comptables générées.
      invalidatesTags: [
        INVALIDATE_CREANCES,
        INVALIDATE_CREANCES_CLIENT,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_PAIEMENT_CREANCES,
        INVALIDATE_ECRITURE,
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateCreanceMutation,
  usePayCreanceMutation,
} = creanceApi;
